import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoreSeoPages } from '@app/store/enums/core-seo-pages';
import { CoreService } from '../../services/core.service';
import { FAQCategories } from '../../services/faqs.service';
import { SeoService } from '../../services/seo.service';
import { SystemUserTypes } from 'shared-library';

@Component({
  selector: 'app-core-redemption-landing-page',
  templateUrl: './core-redemption-landing-page.component.html',
  styleUrls: ['./core-redemption-landing-page.component.scss']
})
export class CoreRedemptionLandingPageComponent implements OnInit {

  show_landing_page = false
  faq_category = FAQCategories.REDEMPTION

  constructor(
    private router: Router,
    private seo: SeoService,
    private coreService: CoreService
  ) {
    this.seo.generateMetaTags(CoreSeoPages.REDEMPTION_LANDING)
  }

  ngOnInit(): void {
    if (this.coreService.isLoggedIn()) {
      if (this.coreService.getSessionInfo().user_details.user_category !== SystemUserTypes.USER) {
        this.router.navigateByUrl("/404")
        return
      }
      this.router.navigateByUrl(`${this.coreService.getSessionInfo().user_details.user_category}/redemption`)
      return
    }
    this.show_landing_page = true
  }

  getStarted() {
    const session_info = this.coreService.getSessionInfo()
    if (session_info) {
      session_info.last_routes.lastvisited = `${SystemUserTypes.USER}/redemption`
      this.coreService.setSessionData(session_info)
    }
    this.router.navigateByUrl("/auth/signin")
  }


}
